import { Zaehlstueck } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { StateV2, StateV3 } from './3_migrate_effektiveZaehlstuecke.interfaces';

export const migrateToEffektiveZaehlstuecke = (
  previousState: StateV2,
  newVersion: number,
): StateV3 => {
  const relevantZaehlstuecke: Array<Zaehlstueck> = previousState.warenkorb.map(produkt => {
    return {
      appId: produkt.produktId,
      kurztext: produkt.kurztext,
      rabattstufe: produkt.rabattstufe,
      isZaehlstueck: produkt.isZaehlstueck,
    };
  });

  let anzahlOhneRabattstufe = previousState.unfallProdukt.zaehlstuecke;
  const relevanteZaehlstuecke = relevantZaehlstuecke.filter(
    zaehlstueck => zaehlstueck.isZaehlstueck,
  );
  const hasThhHund = relevanteZaehlstuecke.some(
    zaehlstueck => zaehlstueck.appId === App.THH_HUND && zaehlstueck.rabattstufe === 0,
  );
  const hasThhPferd = relevanteZaehlstuecke.some(
    zaehlstueck => zaehlstueck.appId === App.THH_PFERD && zaehlstueck.rabattstufe === 0,
  );

  anzahlOhneRabattstufe += relevanteZaehlstuecke.filter(
    zaehlstueck => zaehlstueck.rabattstufe === 0,
  ).length;
  anzahlOhneRabattstufe =
    hasThhPferd && hasThhHund ? anzahlOhneRabattstufe - 1 : anzahlOhneRabattstufe;

  const anzahl = relevanteZaehlstuecke.map(zaehlstueck => zaehlstueck.rabattstufe);
  const effektiveZaehlstuecke = Math.max(...anzahl, anzahlOhneRabattstufe);

  return {
    ...previousState,
    version: newVersion,
    effektiveZaehlstuecke,
  };
};
